import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { action, makeObservable, observable } from 'mobx';

import { Schedule } from 'bringg-web/features/delivery-blocks-v2/settings/schedules/delivery-blocks-schedules';

export class DeliveryBlocksTemplatesStore {
	deliveryBlockSchedules: Schedule[] = [];

	constructor() {
		makeObservable(this, {
			deliveryBlockSchedules: observable,
			setDeliveryBlockSchedules: action
		});
	}

	setDeliveryBlockSchedules = (deliveryBlockSchedules: Schedule[]) => {
		this.deliveryBlockSchedules = deliveryBlockSchedules;
	};

	fetchTemplates = async () => {
		const { dashboardSdk } = getRootEnv();

		const result = await dashboardSdk.sdk.deliveryBlocks.getTemplates();
		const schedules = result.flatMap(({ id, name, template_schedules }) => {
			if (template_schedules.length === 0) {
				template_schedules.push({
					id: -1
				});
			}
			return template_schedules.map(schedule => ({ ...schedule, template_id: id, template_name: name }));
		});
		this.setDeliveryBlockSchedules(schedules);
	};
}
